import { render, staticRenderFns } from "./Singlechoice.vue?vue&type=template&id=b04560b8&"
import script from "./Singlechoice.vue?vue&type=script&lang=ts&"
export * from "./Singlechoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports